<template>
  <!-- Time Tracking, Timesheet and Approvals tabs (Workspace369 lib/view/time_tracking/timesheets/
       week_view.dart, approvals_view.dart, timesheet_submission_detail.dart). Strings are the
       app's (app_en.arb ttTab*, timesheet*Banner, ttSubmitWeek, submitTimesheetTitle,
       ttWaitingForYou, ttApproveWeek, ttRejectEllipsis, ttWeekOfCapacity); hours and people are
       sample data. Approval is optional in the app (off until "Require weekly timesheet
       approval" is turned on). States:
         week      the week grid, Draft
         submit    the "Submit timesheet?" dialog over it
         review    the approver's review panel
         approved  the week, approved and locked -->
  <StoryAppWindow title="Time Tracking" :icon="icons.clock">
    <div class="tss-tabs">
      <span>Entries</span>
      <span :class="{ 'is-on': state !== 'review' }">Timesheet</span>
      <span>Time off</span>
      <span :class="{ 'is-on': state === 'review' }">Approvals <i>1</i></span>
    </div>

    <!-- The member's week -->
    <section class="saw-layer tss-week" :class="{ 'is-on': state === 'week' || state === 'submit' || state === 'approved' }">
      <div class="tss-tool">
        <b>Oct 19 – 25</b>
        <span class="saw-muted saw-num">38h 30m of 40h</span>
      </div>
      <div class="tss-banner" :class="state === 'approved' ? 'tss-banner--ok' : ''">
        <em class="saw-tag" :class="state === 'approved' ? 'saw-tag--green' : 'saw-tag--muted'">{{ state === "approved" ? "Approved" : "Draft" }}</em>
        <span>{{ state === "approved" ? "Approved — entries for this week are locked." : "This week hasn't been submitted for approval yet." }}</span>
        <span v-if="state !== 'approved'" class="saw-btn">Submit week</span>
      </div>
      <div class="saw-card tss-grid">
        <div class="tss-r tss-h"><span>Project</span><span v-for="d in days" :key="d">{{ d }}</span><span>Total</span></div>
        <div v-for="row in grid" :key="row.name" class="tss-r">
          <span class="tss-name"><b>{{ row.name }}</b><small>{{ row.client }}</small></span>
          <span v-for="(h, i) in row.hours" :key="i" class="saw-num" :class="{ 'is-empty': !h }">{{ h || "+" }}</span>
          <b class="saw-num">{{ row.total }}</b>
        </div>
        <div class="tss-r tss-total"><span>Total</span><span v-for="(t, i) in totals" :key="i" class="saw-num">{{ t }}</span><b class="saw-num">38:30</b></div>
      </div>

      <div class="tss-dialog" :class="{ 'is-open': state === 'submit' }">
        <div class="saw-card">
          <b>Submit timesheet?</b>
          <p>You're submitting 21 entries totaling 38h 30m.</p>
          <div class="tss-actions"><span class="saw-btn-quiet">Cancel</span><span class="saw-btn">Submit</span></div>
        </div>
      </div>
    </section>

    <!-- The approver's side -->
    <section class="saw-layer" :class="{ 'is-on': state === 'review' }">
      <div class="tss-tool"><b>Waiting for you</b><span class="saw-muted">Decided</span></div>
      <div class="saw-card tss-review">
        <div class="tss-who">
          <span class="tss-avatar">MO</span>
          <span><b>Maya Ortiz</b><small>Week of Oct 19 · submitted Fri 5:42 PM</small></span>
          <em class="saw-tag saw-tag--amber">Pending</em>
        </div>
        <div class="tss-split"><span class="is-on">By day</span><span>By project</span></div>
        <ul class="tss-days">
          <li v-for="(t, i) in totals.slice(0, 5)" :key="i"><span>{{ days[i] }}</span><i :style="{ width: `${(parseFloat(t) / 9) * 100}%` }" /><b class="saw-num">{{ t }}</b></li>
        </ul>
        <div class="tss-sum"><span>Hours <b class="saw-num">38h 30m</b></span><span>Amount <b class="saw-num">$3,780.00</b></span></div>
        <div class="tss-actions"><span class="saw-btn-quiet">Reject…</span><span class="saw-btn">Approve week</span></div>
      </div>
    </section>
  </StoryAppWindow>
</template>

<script setup>
defineProps({
  state: { type: String, default: "approved" },
});
const days = ["Mon 19", "Tue 20", "Wed 21", "Thu 22", "Fri 23"];
const grid = [
  { name: "Website redesign", client: "Acme Co", hours: ["3:00", "2:30", "4:00", "1:30", "2:00"], total: "13:00" },
  { name: "Brand identity", client: "Northwind Studio", hours: ["3:00", "4:00", "", "4:00", "2:30"], total: "13:30" },
  { name: "Spring launch", client: "Harbor Bakery", hours: ["1:00", "1:00", "1:00", "1:00", "1:00"], total: "5:00" },
  { name: "Internal", client: "Studio", hours: ["1:00", "0:30", "2:00", "1:00", "2:30"], total: "7:00" },
];
const totals = ["8:00", "8:00", "7:00", "7:30", "8:00"];
const icons = {
  clock: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z",
};
</script>

<style scoped>
.tss-tabs { position: absolute; top: 0; right: 0; left: 0; z-index: 1; display: flex; gap: 14px; border-bottom: 1px solid var(--saw-line); background: var(--saw-page); padding: 0 14px; font-size: 12px; }
.tss-tabs span { padding: 8px 0 7px; color: var(--saw-muted); white-space: nowrap; }
.tss-tabs span.is-on { box-shadow: inset 0 -2px 0 var(--saw-ink); color: var(--saw-text); font-weight: 600; }
.tss-tabs i { border-radius: 4px; background: var(--saw-red-fill); color: var(--saw-red); padding: 0 4px; font-size: 10px; font-style: normal; }
.saw-layer { padding-top: 48px; }
.tss-tool { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; font-size: 13px; }
.tss-banner { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 8px; border-radius: 8px; background: var(--saw-card); box-shadow: inset 0 0 0 1px var(--saw-line); padding: 7px 10px; font-size: 11.5px; }
.tss-banner > span:nth-child(2) { flex: 1 1 10rem; }
.tss-banner--ok { background: var(--saw-green-fill); box-shadow: none; }
.tss-banner .saw-btn { padding: 4px 9px; font-size: 11px; }
.tss-grid { overflow: hidden; font-size: 11.5px; }
.tss-r { display: grid; grid-template-columns: minmax(0, 1.7fr) repeat(5, minmax(0, 0.62fr)) minmax(0, 0.7fr); align-items: center; gap: 4px; min-height: 40px; padding: 4px 10px; }
.tss-r + .tss-r { border-top: 1px solid var(--saw-line); }
.tss-r > span:not(.tss-name), .tss-r > b { text-align: center; }
.tss-h { min-height: 30px; color: var(--saw-muted); font-size: 10.5px; }
.tss-name { display: grid; min-width: 0; line-height: 1.25; }
.tss-name b { overflow: hidden; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }
.tss-name small { overflow: hidden; color: var(--saw-muted); font-size: 10px; text-overflow: ellipsis; white-space: nowrap; }
.is-empty { color: var(--saw-muted); }
.tss-total { background: var(--saw-wash); font-weight: 600; }
.tss-dialog { position: absolute; inset: 0; display: grid; place-items: center; background: rgb(0 0 0 / 0.28); padding: 20px; opacity: 0; visibility: hidden; transition: opacity 0.3s, visibility 0s linear 0.3s; }
.tss-dialog.is-open { opacity: 1; visibility: visible; transition: opacity 0.3s; }
.tss-dialog .saw-card { display: grid; gap: 8px; width: min(100%, 300px); padding: 14px; box-shadow: 0 12px 30px rgb(0 0 0 / 0.25); }
.tss-dialog b { font-size: 14px; }
.tss-dialog p { margin: 0; color: var(--saw-muted); font-size: 12px; }
.tss-actions { display: flex; justify-content: flex-end; gap: 6px; }
.tss-review { display: grid; gap: 10px; padding: 12px; }
.tss-who { display: flex; align-items: center; gap: 8px; }
.tss-who > span:nth-child(2) { display: grid; flex: 1; min-width: 0; line-height: 1.3; }
.tss-who small { color: var(--saw-muted); font-size: 11px; }
.tss-avatar { display: grid; place-items: center; width: 30px; height: 30px; border-radius: 50%; background: #13263a; color: #fff; font-size: 11px; font-weight: 600; }
.tss-split { display: grid; grid-template-columns: 1fr 1fr; gap: 3px; border-radius: 7px; background: var(--saw-wash); padding: 3px; font-size: 11.5px; text-align: center; }
.tss-split span { border-radius: 5px; padding: 4px 0; }
.tss-split span.is-on { background: var(--saw-card); font-weight: 600; box-shadow: 0 1px 2px rgb(0 0 0 / 0.12); }
.tss-days { display: grid; gap: 6px; margin: 0; padding: 0; list-style: none; font-size: 11.5px; }
.tss-days li { display: grid; grid-template-columns: 3.6em 1fr 3em; align-items: center; gap: 8px; }
.tss-days i { display: block; height: 8px; border-radius: 2px; background: var(--saw-accent); }
.tss-days b { text-align: right; }
.tss-sum { display: flex; justify-content: space-between; gap: 8px; border-top: 1px solid var(--saw-line); padding-top: 8px; color: var(--saw-muted); font-size: 11.5px; }
.tss-sum b { margin-left: 4px; color: var(--saw-text); }
@media (max-width: 639px) {
  .tss-tabs span:nth-child(3) { display: none; }
  .tss-r { grid-template-columns: minmax(0, 1.4fr) repeat(5, minmax(0, 0.7fr)); padding: 4px 6px; }
  .tss-r > :last-child { display: none; }
  .tss-name small { display: none; }
  .tss-name b { white-space: normal; }
}
</style>
